<template>
  <div v-if="items && items.length">
    <b-table
      v-if="!isMobile"
      id="tbl-prime-log"
      striped
      hover
      small
      class="datatable table-responsive"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="1"
    >
      <template #cell(date)="data">
        <span v-shtml="data.value" />
      </template>
      <template #cell(staffUser)="{ item }">
        <staff-user-label :info="item.staffUser">
          Hostess
        </staff-user-label>
      </template>
      <template #cell(value)="{ item }">
        <b-badge v-if="item.value === 1" variant="success">
          On
        </b-badge>
        <b-badge v-else variant="danger">
          Off
        </b-badge>
      </template>
      <template #bottom-row="">
        <b-pagination
          v-model="currentPage"
          class="p-1 my-0"
          :total-rows="total"
          :per-page="perPage"
          aria-controls="tbl-cost-log"
        />
      </template>
    </b-table>
    <div v-else>
      <timeline :items="items">
        <template #default="{ data: { item } }">
          <h5 class="fw-bold">
            {{ item.date ? $dateFormat(item.date, 'DD/MM/YYYY HH:mm') : '' }}
          </h5>
          <p v-if="item.staffUser" class="text-muted mb-2 fw-bold">
            <staff-user-label :info="item.staffUser">
              Hostess
            </staff-user-label>
          </p>
          <ul class="p-0 pl-3 text-muted">
            <li>
              <strong>{{ $t('fCustomer_primeLog_f_cost') }}</strong>: {{ item.cost }}
            </li>
            <li>
              <strong>{{ $t('fCustomer_primeLog_f_level') }}</strong>: {{ item.level }}
            </li>
            <li>
              <strong>{{ $t('fCustomer_primeLog_f_unlocked_talks') }}</strong>: {{ item.unlocked_talks }}
            </li>
          </ul>
        </template>
      </timeline>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StaffUserLabel from '@/components/forms/CustomerEditForm/Elements/Logs/StaffUserLabel.vue'

export default {
  name: 'PrimeLog',
  components: { StaffUserLabel },
  props: {
    itemId: {
      type: [String, Number],
      required: true
    },
    idx: {
      type: Number,
      default: -1
    },
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      sortBy: 'date',
      sortDesc: true,
      currentPage: this.pagination?.current_page || 1,
      fields: [
        {
          key: 'date',
          label: this.$t('fCustomer_primeLog_f_date'),
          sortable: false,
          tdClass: 'col-2 text-left',
          formatter: (value, key, item) => {
            return item?.date
              ? this.$dateFormat(item.date, 'DD/MM/YYYY<br>HH:mm')
              : ''
          }
        },
        {
          key: 'staffUser',
          label: this.$t('fCustomer_primeLog_f_staff_user'),
          sortable: false,
          formatter: (value) => {
            return value && `${value.email}&nbsp;(Id:&nbsp;${value.id})`
          }
        },
        {
          key: 'value',
          label: this.$t('fCustomer_primeLog_f_value'),
          tdClass: 'col-2 text-right'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getByName: 'repos/getByName',
      deviceInfo: 'device'
    }),
    isMobile () {
      return this.deviceInfo?.type === 'mobile' || false
    },
    total () {
      return this.pagination?.total || 0
    },
    perPage () {
      return this.pagination?.per_page || 10
    }
  },
  watch: {
    currentPage (p) {
      if (p && p !== (this.pagination?.current_page || 1)) {
        this.$emit('goToPage', p)
      }
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions({})
  }
}
</script>

<style scoped>

</style>
